export default {
    async beforeRouteEnter(to, from, next) {
        next(async (vm) => {
            if (!vm.$store.state.auth?.currentUser?.account_types?.filter(item => item.name === "MENTOR").length) {
                await vm.$router.push(from.path);
            } else {
                next()
            }
        })

    }
}
